import * as SC from '@/components/login/LoginBtn.style';
import strings from '@/i18n';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

const LoginBtn = ({ ...args }: Props) => {
  return (
    <SC.Wrapper {...args}>
      <SC.Label>{strings.LOGIN}</SC.Label>
    </SC.Wrapper>
  );
};

export default LoginBtn;
